<template>
  <div class="echarts">
    <IEcharts :option="bar" :loading="loading" />
  </div>
</template>

<script>
import IEcharts from "vue-echarts-v3/src/full.js";
export default {
  name: "BusinessChart",
  components: {
    IEcharts
  },
  props: {
    DetailParams: {
      type: Object,
      default: () => {}
    },
    Titulo: String,
    Url: String
  },
  data: () => ({
    loading: true,
    bar: {
      title: {
        text: "Gráfico Detalle"
      },
      tooltip: {},
      xAxis: {
        data: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31"
        ]
      },
      yAxis: {},
      series: [
        {
          name: "",
          type: "line",
          data: []
        },
        {
          name: "Linea 2 ",
          type: "line",
          data: []
        }
      ]
    }
  }),
  methods: {
    async getChartData() {
      const that = this;
      await this.$http
        .get(this.Url, {
          params: {
            CompanyId: this.DetailParams.CompanyId,
            year: this.DetailParams.Year,
            Deteals: this.DetailParams.Deteals,
            month: this.DetailParams.Month,
            Phaseid: this.DetailParams.Phaseid,
            CreatedBy: this.DetailParams.CreatedBy,
            deparmentId: this.DetailParams.DeparmentId,
            SalesCode: this.DetailParams.SalesCode
          }
        })
        .then((resp) => {
          that.bar.series[0].data = Object.values(resp.data[0]);
          // that.bar.series[1].data = Object.values(resp.data[1]);

          // that.bar.series[1].data = Object.values(resp.data[1]);
          if (this.DetailParams.Deteals == "Indice de Cierre") {
            that.bar.series[1].data = Object.values(resp.data[1]);
          } else {
            that.bar.series[1].data = 0;
          }

          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.echarts {
  width: 93%;
  height: 400px;
  background-color: #f3f7fa;
  border-radius: 30px;
  margin: 30px;
  padding: 10px;
}
</style>
